import React, { useState, useEffect } from 'react';
import Modal from '../../components/common/Modal'; // Asumiendo que tienes un componente Modal genérico
import { db } from '../../firebase';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import '../../styles/Modal.css'; // Asumiendo estilos comunes para modales

const AgreementHistoryModal = ({ agreementId, userId, onClose }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!agreementId || !userId) {
            setError("No se pudo cargar el historial: ID de acuerdo o usuario faltante.");
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        // Consulta las balance_transactions para el usuario y acuerdo específicos
        const q = query(
            collection(db, `users/${userId}/balance_transactions`),
            where('sourceTransactionId', '==', agreementId),
            orderBy('createdAt', 'desc')
        );

        let cancelled = false;
        let intervalId = null;

        const fetchHistory = async () => {
            try {
                const snap = await getDocs(q);
                if (cancelled) return;
                const transactions = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                setHistory(transactions);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching agreement history:', err);
                if (!cancelled) {
                    setError('Error al cargar el historial de transacciones.');
                    setLoading(false);
                }
            }
        };

        fetchHistory();
        intervalId = setInterval(fetchHistory, 5000);

        return () => {
            cancelled = true;
            if (intervalId) clearInterval(intervalId);
        };
    }, [agreementId, userId]);

    return (
        <Modal isOpen={true} onClose={onClose} title={`Historial de Acuerdo #${agreementId?.substring(0, 6)}`}>
            {loading && <p>Cargando historial...</p>}
            {error && <p className="error-message">{error}</p>}
            {!loading && history.length === 0 && <p>No hay transacciones registradas para este acuerdo.</p>}

            {!loading && history.length > 0 && (
                <div className="table-responsive-wrapper" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Tipo</th>
                                <th>Monto</th>
                                <th>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map(tx => (
                                <tr key={tx.id}>
                                    <td>{tx.createdAt?.toDate().toLocaleString('es-ES') || 'N/A'}</td>
                                    <td>{tx.type?.replace(/_/g, ' ') || 'N/A'}</td>
                                    <td className={tx.amount >= 0 ? 'amount-positive' : 'amount-negative'}>
                                        {tx.amount >= 0 ? '+' : '-'}${Math.abs(tx.amount || 0).toFixed(2)}
                                    </td>
                                    <td>{tx.description || 'N/A'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </Modal>
    );
};

export default AgreementHistoryModal;